import React from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';

import Form from './SubscriptionsPayments/Form';

import { STRIPE_PUBLIC_KEY } from "babel-dotenv";

const stripePromise = loadStripe(STRIPE_PUBLIC_KEY);

class SubscriptionsPaymentsApp extends React.Component {
  render() {
    return (
      <Elements stripe={stripePromise}>
        <Form
          countryCode={this.props.countryCode}
          formData={this.props.formData}
          translations={this.props.translations}
          links={this.props.links}>
        </Form>
      </Elements>
    );
  };
};

export default SubscriptionsPaymentsApp;
